import SystemManagementComponent from "components-base/pages/systemmanagement/systemmanagement";
export const SystemManagement = () =>{
    return(
        <div className="flex w-full flex-col gap-5"><SystemManagementComponent /></div>
    )
}
export default SystemManagement;